import ApiService from "../services/api";
import {
  SupportGroup,
  SupportGroupAssignableUser,
  SupportGroupFilters,
  SupportGroupFormData,
} from "../models/supportGroup";

const BASE_URL = `${import.meta.env.VITE_API_TAS}/support/groups`;

const api = () => new ApiService(import.meta.env.VITE_API_TAS);

export const fetchSupportGroups = async (filters: SupportGroupFilters): Promise<SupportGroup[]> => {
  const response = await api().get<{ content: SupportGroup[] }>(BASE_URL, {
    params: { ...filters, page: 0, size: 100 },
  });
  return response.data.content ?? [];
};

export const fetchSupportGroup = async (id: number): Promise<SupportGroup> => {
  const response = await api().get<SupportGroup>(`${BASE_URL}/${id}`);
  return response.data;
};

export const createSupportGroup = async (data: SupportGroupFormData): Promise<SupportGroup> => {
  const response = await api().post<SupportGroup>(BASE_URL, data);
  return response.data;
};

export const updateSupportGroup = async (id: number, data: SupportGroupFormData): Promise<SupportGroup> => {
  const response = await api().put<SupportGroup>(`${BASE_URL}/${id}`, data);
  return response.data;
};

export const deleteSupportGroup = async (id: number): Promise<void> => {
  await api().delete(`${BASE_URL}/${id}`);
};

export const fetchSupportGroupsAvailableForAssignment = async (): Promise<SupportGroup[]> => {
  try {
    const response = await api().get<SupportGroup[]>(`${BASE_URL}/available-for-assignment`);
    return response.data ?? [];
  } catch (error) {
    console.error('Error fetching support groups:', error);
    return [];
  }
};

export const fetchSupportGroupUsers = async (groupId: number): Promise<SupportGroupAssignableUser[]> => {
  const response = await api().get<SupportGroupAssignableUser[]>(`${BASE_URL}/${groupId}/users`);
  return response.data ?? [];
};
